export const CHANGE_PAGE_EVENT = 'siteBuilder:page:change';
